.whoosh-apple-pay-button {
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: buy;
  -apple-pay-button-style: black;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  display: block;
  min-height: 44px;
  min-width: 140px;
  width: 100%;
}

.whoosh-apple-pay-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
